// Results list for the GoBar command palette modal.
import {
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { useT } from '@/i18n/useT';

const GoBarModalResultsList = ({
  displayItems,
  selectedIndex,
  onItemClick,
}) => {
  const t = useT();

  return (
    <List
      id="gobar-listbox"
      role="listbox"
      sx={{ mt: 1, maxHeight: '50vh', overflow: 'auto', px: 0 }}
    >
      {displayItems.length === 0 ? (
        <Typography
          sx={{ p: 2, color: 'text.secondary', textAlign: 'center' }}
        >
          {t('gobar.noResults', 'No tasks found')}
        </Typography>
      ) : (
        displayItems.map((item, index) => (
          <ListItem
            key={item.id}
            id={`gobar-option-${item.id}`}
            role="option"
            aria-selected={index === selectedIndex}
            onClick={() => onItemClick(item)}
            sx={{
              borderRadius: 1,
              cursor: 'pointer',
              mb: 0.5,
              bgcolor:
                index === selectedIndex ? 'action.selected' : 'transparent',
              '&:hover': { bgcolor: 'action.hover' },
            }}
          >
            <ListItemText
              primary={item.title}
              primaryTypographyProps={{
                fontWeight: index === selectedIndex ? 'bold' : 'normal',
                color:
                  item.isCommand || item.isCreate
                    ? 'primary.main'
                    : 'inherit',
              }}
            />
          </ListItem>
        ))
      )}
    </List>
  );
};

export default GoBarModalResultsList;
